import {InstagramPostChartDTO} from './chart/InstagramPostChartDTO';
import {TikTokPostChartDTO} from './chart/TikTokPostChartDTO';
import {Page} from '../lib/core/common/dto/Page';

export class HomeInfoDTO {
  instagramPostChart: Page<InstagramPostChartDTO>;
  tikTokPostChart: Page<TikTokPostChartDTO>;
}
